import './downloads-tabs.scss';
import AjaxLoad from '../../utilities/js/ajax-loader';

class DownloadsTabs {
    constructor (element) {
        this.$tabs = element;
        this.$tabTitle = this.$tabs.querySelectorAll('[data-tab-title]');
        this.$tabContent = this.$tabs.querySelectorAll('[data-tab-content]');
    }

    initialize () {
        this.setEvents();
    }

    // set click event for each tab title
    setEvents () {
        for (let i = 0; i < this.$tabTitle.length; i++) {
            this.$tabTitle[i].addEventListener('click', (event) => {
                const titleId = this.$tabTitle[i].getAttribute('data-tab-title');

                this.setTab(titleId, event);
            });
        }
    }

    // set tab events
    setTab (titleId, event) {
        this.setContentActive(titleId);
        this.setTitleActive(event);
    }

    // set active tab function
    setTitleActive (event) {
        const title = event.target;

        for (let i = 0; i < this.$tabTitle.length; i++) {
            if (!title.classList.contains('is-active')) {
                // removes all active classes from not active tabs
                this.$tabTitle[i].classList.remove('is-active');
            }
        }

        window.setTimeout(() => {
            title.classList.add('is-active');
        }, 500);
    }

    // set content active, load and replace content via ajax
    setContentActive (titleId) {
        for (let i = 0; i < this.$tabContent.length; i++) {
            const contentId = this.$tabContent[i].getAttribute('data-tab-content');
            const contentUrl = this.$tabContent[i].getAttribute('data-assets-url');
            const contentWrapper = this.$tabContent[i].querySelector('[data-downloads="wrapper"]');
            const contentLength = this.$tabContent[i].querySelector('[data-downloads-items]');

            if (titleId === contentId) {
                this.$tabContent[i].classList.add('is-active');
                new AjaxLoad(contentUrl, { // eslint-disable-line
                    requestMethod: 'GET',
                    onSuccess: (resultText) => {
                        contentWrapper.innerHTML = resultText;
                        contentLength.setAttribute('data-downloads-items', contentWrapper.children.length);

                        const contentUpdateEvent = new CustomEvent('content.loaded', {
                            view: window,
                            bubbles: true,
                            cancelable: false,
                            detail: {
                                $context: this.$tabs
                            }
                        });

                        window.dispatchEvent(contentUpdateEvent);
                    }
                });
            } else {
                this.$tabContent[i].classList.remove('is-active');
                contentWrapper.innerHTML = '';
                contentLength.setAttribute('data-downloads-items', 0);
                contentWrapper.classList.remove('is-active');
                contentWrapper.classList.remove('is--null');
            }
        }
    }
}

export { DownloadsTabs };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-download-tabs="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new DownloadsTabs($root);
            $rootAPI.initialize();
        });
    }
});
